import { WorkspaceMembershipSchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const WORKSPACE_MEMBER_TABLE = '"public"."workspaceMemberships"'

export const WorkspaceMembershipConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: WORKSPACE_MEMBER_TABLE,
  partitionKey: 'workspace_id',
  key: 'userId',
  apiEndpoint: '/api/workspace/[workspaceId]/members',
  where: {},
  schema: WorkspaceMembershipSchema,
}
